module.exports = __webpack_public_path__ + "assets/img/00142.cbcd0617.png";